export default __webpack_public_path__ + "static/media/toilichte.a3528303.mp3";